<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
          :showBtn="false"
          title="Incentive Payment Voucher List"
          btnTitle="Add New"
          :showAddNew="true"
          @onClickAddNewButton="onClickAddNewButton"
      />
    </div>
    <div class="my-2 px-2">
      <DateQuerySetter
          btnTitle="Go"
          @onClickGo="onClickToGo"
          class="tds-vds-query-setter"
      >
      </DateQuerySetter>
    </div>

    <div class="col-12 px-2 mt-2 mb-4">
      <div class="card p-2" style="min-height: 200px">
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>Date</th>
              <th>Voucher No</th>
              <th>Description</th>
              <th>Amount</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in tableItems" :key="i">
              <td>
                <span class="fw-bold">{{ item.date }}</span>
              </td>
              <td>{{ item.voucher_no }}</td>
              <td> {{item.note}} </td>
              <td> {{ commaFormat(item.total_amount) }} </td>
              <td>
                <button class="btn btn-secondary btn-sm"
                        @click="goToPrint(item.id)"
                        style="cursor: pointer; margin-left: 10px"
                >
                  <i class="fas fa-print"></i>
                </button>
              </td>
            </tr>

            </tbody>
          </table>
          <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
        </div>
      </div>
    </div>

    <div class="px-2 position-absolute bottom-0 mt-4">
      <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
    </div>

    <Loader v-if="loading"/>

  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import { computed } from 'vue';
import figureFormatter from '@/services/utils/figureFormatter'
import handleJournal from '@/services/modules/journal'
import handleSdm from "@/services/modules/sdm/sdm";
import incentivePaymentVoucherPdfHelper from "@/services/utils/incentivePaymentVoucherPdfHelper";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const paymentRes = ref({});
const params = ref({
  offset: 10,
});
const {commaFormat} = figureFormatter()
const token = computed(() => localStorage.getItem('token'));
const {
  fetchJournals,
} = handleJournal()
const { fetchSingleIncentivePaymentVoucher } = handleSdm()
const { generatePdf } = incentivePaymentVoucherPdfHelper();

const onClickToGo = () => {
  getIncentiveData();
}

function onClickAddNewButton() {
  router.push({name: `incentive-payment-voucher`, params: route.params, query: route.query})
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getIncentiveData();
}
const getIncentiveData = async () => {
  const query = getQuery();
  loading.value = true
  tableItems.value = []

  await fetchJournals(query).then(res => {
    if (!res.status){
      store.commit("resetPagination")
      return
    }

    tableItems.value = res.data.data;
    setPagination(res.data)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const goToPrint = (id) => {
  let companyId = route.params.companyId;
  const companyQuery = `?company_id=${companyId}`;
  fetchSingleIncentivePaymentVoucher(id, companyQuery).then( (res) => {
    if(res){
      paymentRes.value = res.data;
    }}).then (() => {
    generatePdf(companyId, paymentRes.value)
  }).catch((err) => {
    console.log('Something went wrong');
  })
}

const getQuery = () => {
  let query = `?company_id=${route.params.companyId}`;
  if (route.query.page) query += '&page=' + route.query.page;
  if (route.query.start) query += '&start_date=' + route.query.start;
  if (route.query.end) query += '&end_date=' + route.query.end;
  query += '&offset=' + params.value.offset;
  query += '&voucher_type=payment_voucher&txn_type=incentive_payment'
  return query;
}

onMounted(() => {
  Promise.all([
    getIncentiveData(),
  ])
})
</script>
